module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  Settings\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d139bafe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings.vue
// module id = 568
// module chunks = 1